// extracted by mini-css-extract-plugin
export default {"tabList":"TabList_tabList__yMTxx","default":"TabList_default__2He-P","buttonsGroup":"TabList_buttonsGroup__hLsKX"};